import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styled from '@emotion/native';
import { BaseText } from '@/shared/components/StyledText';
import { black, green, offWhite } from '@/shared/styles/colors';

interface Props {
  value: boolean;
  onValueChange: (value: boolean) => void;
  showOptional?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}

const RADIO_HIT_SLOP = { top: 8, bottom: 8, left: 8, right: 8 };

const ShareAgeRadio = ({
  value,
  onValueChange,
  showOptional = false,
  containerStyle,
}: Props) => {
  return (
    <Container style={containerStyle}>
      <RadioButton
        onPress={() => onValueChange(!value)}
        hitSlop={RADIO_HIT_SLOP}
      >
        <RadioOuter>{value && <RadioInner />}</RadioOuter>
      </RadioButton>
      <LabelText onPress={() => onValueChange(!value)}>
        Share age with your stylists{showOptional ? ' (optional)' : ''}
      </LabelText>
    </Container>
  );
};

const Container = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 16,
  marginBottom: 8,
});

const RadioButton = styled.TouchableOpacity({
  marginRight: 8,
});

const RadioOuter = styled.View({
  width: 30,
  height: 30,
  borderRadius: 30,
  borderWidth: 1,
  borderColor: green,
  backgroundColor: offWhite,
  alignItems: 'center',
  justifyContent: 'center',
});

const RadioInner = styled.View({
  width: 20,
  height: 20,
  borderRadius: 20,
  backgroundColor: green,
});

const LabelText = styled(BaseText)({
  fontSize: 14,
  fontWeight: '400',
  color: black,
});

export default ShareAgeRadio;
